import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import DataTable from 'datatables.net-bs5';
import { Subject } from 'rxjs';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../Model/utility/utility.service';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import * as XLSX from 'xlsx';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
@Component({
  selector: 'app-client-holiday-form',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule],
  templateUrl: './client-holiday-form.component.html',
  styleUrl: './client-holiday-form.component.scss'
})
export class ClientHolidayFormComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  ClientHolidayHistoryData: any[] = [];
  ClientData: any[] = [];
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  Years = [] as any;
  filter = {
    SelectType: 5,
    ClientId: null as any,
    StateId: null,
    Year: null as any,
    TypesOfLeave: null,
    ClientIdObj: null as any,
  }
  // Hyear? : string;
  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    private toast: ToastService,
    private holiday: HolidayService,
    private combo: ComboService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private router: Router,
    private download: DownloadSampleService,
    protected common: CommonService,
    private sessionService: SessionService
  ) {
    this.common.getPageRights();
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }
  HistoryFilterOnYear() {
    this.GetClientHolidayHistory();
  }
  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.filter.Year = currentYear;
    this.GetClientHolidayHistory();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetClientHolidayHistory() {
    this.isDisabled = true;
    this.holiday.GetClientHoliday(this.filter).subscribe({
      next: (response) => {
        this.ClientHolidayHistoryData = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);

        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  //Added By Pooja on 10th May 2024 As per discussion with Sakshi 
  handleFileInput(event: any): void {
    this.ClientData.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueHolidayIds: Set<number> = new Set();
         
        this.ClientData = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });
          const id = rowData['ESS_ClientHolidayID'];
          const date = rowData['Date'];
          let holidayName = rowData['HolidayName'].toString();
          let stateName = rowData['StateName'].toString();
          let year = rowData['Year'];
          let ClientName = rowData['ClientName'].toString();
          
          holidayName = holidayName ? holidayName.trim() : '';
          stateName = stateName ? stateName.trim() : '';
          ClientName = ClientName ? ClientName.trim() : '';
          if (id !== 0 && uniqueHolidayIds.has(id)) {
            this.toast.show({ message: `Duplicate ClientHoliday ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (year.toString().length != 4 || year === '' || year === null || year === undefined) {
            this.toast.show({ message: `Invalid Year is at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (stateName === '' || stateName === null || stateName === undefined) {
            this.toast.show({ message: `State name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (ClientName === '' || ClientName === null || ClientName === undefined) {
            this.toast.show({ message: `Client name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (holidayName === '' || holidayName === null || holidayName === undefined) {
            this.toast.show({ message: `Holiday name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (typeof date !== 'string' || date === undefined || date === null) {
            this.toast.show({ message: `Date Format should be in 'DD MMM YYYY' at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else {
            uniqueHolidayIds.add(id);
          }
          rowData['HolidayName'] = holidayName;
          rowData['StateName'] = stateName;
          rowData['ClientName'] = ClientName;
          rowData['ESS_ClientHolidayID'] = id ?? '';
          this.ClientData.push(rowData);
        }
        this.BulkInsertUpdate(this.ClientData);
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.ClientData.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const CompanyHolidayData = {
      SelectType: 'upload',
      ESS_ClientHolidayInsert: Data,
      UserId: this.User.UserId,
    };
    this.holiday.BulkClientHolidayInsertUpdate(CompanyHolidayData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.GetClientHolidayHistory();
      },
      error => {
        console.error('Error:', error);
      });
  }

  downloadExcel() {
    this.download.downloadExcel('ClientHolidayMaster');
  }
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'ClientHolidayExcel',
      Year: this.filter.Year
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.ClientData = data;
        if (this.ClientData.length > 0) {
          this.download.exportToExcel(this.ClientData, "ClientHoliday_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
}
